import * as _ from 'underscore';

import { ColorBoxField } from '../../../../_common/platform/ts/ColorBoxField'; //LL: 28.09.18
import NumberField from '../../../../_common/platform/ts/NumberField';
import BooleanField from '../../../../_common/platform/ts/BooleanField';
import SelectField from '../../../../_common/platform/ts/SelectField';
import { validators } from '../../../../_common/platform/ts/validators';
import { validators as cardValidators } from '../validators';
import * as appTheme from '../../../../_common/platform/ts/appTheme';
import { init as widgetTheme } from '../../../../pdc-platform/src/ts/themes/widgetTheme';
import { FontField } from '../../../../_common/platform/ts/FontField';
import { LayoutThemeField } from './LayoutTheme';
import { TemplateListField } from './TemplateList';

declare var require: any;

const template = require('!!raw-loader!pdc-widget-cards2/src/mainTheme.template.css').default;
import * as Config from '../config';

template;

declare var Color: any;

var _init = [];

export function init(glob) {
    if (_.indexOf(_init, glob) !== -1) {
        return;
    }
    widgetTheme(glob);

    appTheme.registerSections([
        {
            id: Config.themeId,
            name: 'Cards',
            parent: 'widget',
            //preview: ThemePreview,
            previewClassName: 'widget-card-preview',
            themeType: 'Widget Cards',
            visibility: ['application', 'workspace', 'pdc-widget-cards2']
        },
        {
            id: Config.themeId + '-template',
            name: 'Templates',
            parent: Config.themeId,
            //preview: ThemePreview,
            previewClassName: 'widget-card-preview',
            themeType: 'Widget Cards',
            visibility: ['application', 'workspace', 'pdc-widget-cards2']
        }
    ]);

    appTheme.registerGroups([
        {
            id: 'widget-cards2-header-font',
            name: 'Cards Header Font',
            section: Config.themeId
        },

        {
            id: 'widget-cards2-font',
            name: 'Cards Font',
            section: Config.themeId
        },

        {
            id: 'widget-cards2-dataRetrieving',
            name: 'Data Retrieving',
            section: Config.themeId
        }
    ]);

    appTheme.registerVars([
        {
            id: 'widget-cards2-space',
            param: new NumberField(glob, 'Space Between Cards', [validators.number.integer], 5),
            section: Config.themeId
        },

        {
            id: 'widget-cards2-padding',
            param: new NumberField(
                glob,
                'Card Body Padding',
                [validators.number.range(0, 100), validators.number.integer],
                20
            ),
            section: Config.themeId
        },

        {
            id: 'widget-cards2-container-padding', //to shift it to left; then the scroll bar does not override the rightest cards, 1rem by default
            param: new NumberField(
                glob,
                'Card Body Container Padding',
                [validators.number.range(0, 100), validators.number.integer],
                16
            ),
            section: Config.themeId
        },

        {
            id: 'widget-cards2-border-width',
            param: new NumberField(
                glob,
                'Cards Frame Border Width',
                [validators.number.range(0, 20), validators.number.integer],
                1
            ),
            section: Config.themeId
        },
        {
            id: 'widget-cards2-always-show-border',
            param: new BooleanField(glob, 'Show border', [], true),
            section: Config.themeId
        },
        {
            id: 'widget-cards2-border-has-shadow',
            param: new BooleanField(glob, 'Has Shadows', [], function (theme): boolean {
                return theme['base-has-shadow'];
            }),
            section: Config.themeId,
            deps: ['base-has-shadow']
        },

        {
            id: 'widget-cards2-border-radius',
            param: new NumberField(
                glob,
                'Cards Frame Border Radius',
                [validators.number.range(0, 20), validators.number.integer],
                3
            ),
            section: Config.themeId
        },

        {
            id: 'widget-cards2-border-color',
            param: new ColorBoxField(
                glob,
                'Cards Frame Border Color',
                [],
                function (theme) {
                    return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.5).hexString();
                },
                { hideTransparency: false }
            ),
            section: Config.themeId,
            deps: ['gray-base', 'surface-bg']
        },

        {
            id: 'widget-cards2-header-bg',
            param: new ColorBoxField(
                glob,
                'Cards Header Background Color',
                [],
                function (theme) {
                    return Color(theme['secondary-bg']).hexString();
                },
                { hideTransparency: false }
            ),
            section: Config.themeId,
            deps: ['secondary-bg']
        },

        {
            id: 'widget-cards2-header-color',
            param: new ColorBoxField(
                glob,
                'Cards Header Foreground Color',
                [],
                function (theme) {
                    return Color(theme['on-secondary']).hexString();
                },
                { hideTransparency: false }
            ),
            section: Config.themeId,
            deps: ['on-secondary']
        },
        {
            id: 'widget-cards2-header-font',
            param: new FontField(
                glob,
                'Font Face',
                [],
                function (theme) {
                    return theme['#font-main'];
                },
                {}
            ),
            section: Config.themeId,
            group: 'widget-cards2-header-font',
            deps: ['#font-main']
        },
        {
            id: 'widget-cards2-header-font-size',
            param: new SelectField(
                glob,
                'Font Size',
                [],
                function (theme) {
                    return theme['font-main-size'];
                },
                {
                    values: [
                        'default',
                        'xx-small',
                        'x-small',
                        'small',
                        'medium',
                        'large',
                        'x-large',
                        'xx-large',
                        'smaller',
                        'larger'
                    ],
                    display: [
                        'default',
                        'xx-small',
                        'x-small',
                        'small',
                        'medium',
                        'large',
                        'x-large',
                        'xx-large',
                        'smaller',
                        'larger'
                    ]
                }
            ),
            section: Config.themeId,
            group: 'widget-cards2-header-font',
            deps: ['font-main-size']
        },
        {
            id: 'widget-cards2-header-font-weight',
            param: new SelectField(
                glob,
                'Font Weight',
                [],
                function (theme) {
                    return theme['font-main-weight'];
                },
                {
                    values: ['lighter', 'normal', 'bold', 'bolder'],
                    display: ['lighter', 'normal', 'bold', 'bolder']
                }
            ),
            section: Config.themeId,
            group: 'widget-cards2-header-font',
            deps: ['font-main-weight']
        },
        {
            id: 'widget-cards2-header-font-italic',
            param: new BooleanField(glob, 'Italic', [], function (theme) {
                return theme['font-main-italic'];
            }),
            section: Config.themeId,
            group: 'widget-cards2-header-font',
            deps: ['font-main-italic']
        },

        {
            id: 'widget-cards2-bg',
            param: new ColorBoxField(
                glob,
                'Cards Background Color',
                [],
                function (theme) {
                    return Color(theme['surface-bg']).hexString();
                },
                { hideTransparency: false }
            ),
            section: Config.themeId,
            deps: ['surface-bg']
        },

        {
            id: 'widget-cards2-color',
            param: new ColorBoxField(
                glob,
                'Cards Foreground Color',
                [],
                function (theme) {
                    return Color(theme['gray-base']).hexString();
                },
                { hideTransparency: false }
            ),
            section: Config.themeId,
            deps: ['gray-base']
        },
        {
            id: 'widget-cards2-font',
            param: new FontField(
                glob,
                'Font Face',
                [],
                function (theme) {
                    return theme['#font-main'];
                },
                {}
            ),
            section: Config.themeId,
            group: 'widget-cards2-font',
            deps: ['#font-main']
        },
        {
            id: 'widget-cards2-font-size',
            param: new SelectField(
                glob,
                'Font Size',
                [],
                function (theme) {
                    return theme['font-main-size'];
                },
                {
                    values: [
                        'default',
                        'xx-small',
                        'x-small',
                        'small',
                        'medium',
                        'large',
                        'x-large',
                        'xx-large',
                        'smaller',
                        'larger'
                    ],
                    display: [
                        'default',
                        'xx-small',
                        'x-small',
                        'small',
                        'medium',
                        'large',
                        'x-large',
                        'xx-large',
                        'smaller',
                        'larger'
                    ]
                }
            ),
            section: Config.themeId,
            group: 'widget-cards2-font',
            deps: ['font-main-size']
        },
        {
            id: 'widget-cards2-font-weight',
            param: new SelectField(
                glob,
                'Font Weight',
                [],
                function (theme) {
                    return theme['font-main-weight'];
                },
                {
                    values: ['lighter', 'normal', 'bold', 'bolder'],
                    display: ['lighter', 'normal', 'bold', 'bolder']
                }
            ),
            section: Config.themeId,
            group: 'widget-cards2-font',
            deps: ['font-main-weight']
        },
        {
            id: 'widget-cards2-font-italic',
            param: new BooleanField(glob, 'Italic', [], function (theme) {
                return theme['font-main-italic'];
            }),
            section: Config.themeId,
            group: 'widget-cards2-font',
            deps: ['font-main-italic']
        },

        {
            id: 'widget-cards2-hide-overflow',
            param: new BooleanField(glob, 'Hide Cards Container Overflow', [], false),
            section: Config.themeId
        },

        {
            id: 'widget-cards2-always-show-header',
            param: new BooleanField(glob, 'Always Show Cards Header', [], false),
            section: Config.themeId
        },

        {
            id: 'widget-cards2-layout-field',
            param: new LayoutThemeField(
                glob,
                '',
                [
                    cardValidators.number.countPositive,
                    cardValidators.number.heightPositive,
                    cardValidators.number.widthPositive
                ],
                {
                    layout: 'flow',
                    count: 5,
                    size: 'auto',
                    height: 150,
                    width: 250
                }
            ),
            section: Config.themeId
        },
        {
            id: 'widget-cards2-dataRetrieving-specialMainGroupHandling',
            param: new BooleanField(glob, 'Special Main Group Handling (Always TRUE for TOP2 Delta Card)', [], false),
            section: Config.themeId,
            group: 'widget-cards2-dataRetrieving'
        },

        {
            id: 'widget-cards2-dataRetrieving-cleanCards',
            param: new BooleanField(glob, 'Clean Cards before Data retrieving', [], false),
            section: Config.themeId,
            group: 'widget-cards2-dataRetrieving'
        },

        {
            id: 'widget-cards2-templates',
            param: new TemplateListField(glob, 'Templates', [], []),

            isArray: true,
            merger: appTheme.mergerForArrays,
            section: Config.themeId + '-template'
        }
    ]);

    appTheme.registerTemplate(template, ['pdc-widget-cards2']);

    _init.push(glob);
}
